export async function initWidget() {
  try {
    const { CopilotApi } = await import('../api/copilotApi');
    const settings = await CopilotApi.getPublicSettings();
    if (!settings || !settings.enabled || !settings.enablePublicWidget) {
      const existing = document.getElementById('loumars-copilot-widget');
      existing?.remove();
      return;
    }

    const [ReactModule, ReactDOMClient, MuiMaterial, { PublicChatWidget }] = await Promise.all([
      import('react'),
      import('react-dom/client'),
      import('@mui/material'),
      import('./PublicChatWidget'),
    ]);

    const React = ReactModule.default || ReactModule;
    const { createRoot } = ReactDOMClient;
    const { ThemeProvider, createTheme, CssBaseline } = MuiMaterial;

    const widgetTheme = createTheme({
      palette: {
        mode: 'dark',
        background: {
          default: '#0f172a',
          paper: '#1e293b',
        },
        primary: {
          main: '#f59e0b',
          contrastText: '#0f172a',
        },
        text: {
          primary: '#f8fafc',
          secondary: '#94a3b8',
        },
      },
      shape: {
        borderRadius: 8,
      },
    });

    let mountNode = document.getElementById('loumars-copilot-widget');
    if (!mountNode) {
      mountNode = document.createElement('div');
      mountNode.id = 'loumars-copilot-widget';
      document.body.appendChild(mountNode);
    }

    const root = createRoot(mountNode);
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={widgetTheme}>
          <CssBaseline />
          <PublicChatWidget initialSettings={settings} />
        </ThemeProvider>
      </React.StrictMode>
    );
  } catch {
    const existing = document.getElementById('loumars-copilot-widget');
    existing?.remove();
  }
}

const scheduleInit = () => {
  if (typeof window !== 'undefined') {
    let triggered = false;
    const trigger = () => {
      if (triggered) return;
      triggered = true;
      window.removeEventListener('pointerdown', trigger);
      window.removeEventListener('scroll', trigger);
      window.removeEventListener('keydown', trigger);
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => initWidget(), { timeout: 4000 });
      } else {
        setTimeout(initWidget, 1500);
      }
    };

    window.addEventListener('pointerdown', trigger, { passive: true, once: true });
    window.addEventListener('scroll', trigger, { passive: true, once: true });
    window.addEventListener('keydown', trigger, { passive: true, once: true });
  }
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
}
